import contract from '@mailobj-browser/front/js/contracts/contract.js'
import reminder from './reminder/reminder.js'
import todo from './todo/todo.js'
import search from './search/search.js'
import view from './view/view.js'
import event from './event/event.js'

export default contract({
    event,
    reminder,
    todo,
    search,
    view
})
